import TextTranslator from "./components/TextTranslator";
import {TextTranslationProvider} from "../../contexts/TextTranslationContext";

const TextTranslatorPage = () => {
    return (
        <TextTranslationProvider>
            <TextTranslator/>
        </TextTranslationProvider>
    )
};

export default TextTranslatorPage;